var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurnitureFixtures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7598 26.36H10.2398L9.14979 5.52C9.02979 3.06 10.9798 1 13.4398 1H38.5498C41.0098 1 42.9698 3.06 42.8398 5.52L41.7598 26.36Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7706 33.57H10.2306C8.39062 33.57 6.89062 32.08 6.89062 30.23V29.69C6.89062 27.85 8.38062 26.35 10.2306 26.35H41.7706C43.6106 26.35 45.1106 27.84 45.1106 29.69V30.23C45.1106 32.08 43.6106 33.57 41.7706 33.57Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7705 33.57L13.5505 49.22C13.3005 50.43 12.1305 51.2 10.9205 50.96C9.7105 50.71 8.9405 49.54 9.1805 48.33L12.1305 33.88",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2305 33.57L38.4505 49.22C38.7005 50.43 39.8705 51.2 41.0805 50.96C42.2905 50.71 43.0605 49.54 42.8205 48.33L39.8705 33.88",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7598 26.36H10.2398L9.14979 5.52C9.02979 3.06 10.9798 1 13.4398 1H38.5498C41.0098 1 42.9698 3.06 42.8398 5.52L41.7598 26.36Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7706 33.57H10.2306C8.39062 33.57 6.89062 32.08 6.89062 30.23V29.69C6.89062 27.85 8.38062 26.35 10.2306 26.35H41.7706C43.6106 26.35 45.1106 27.84 45.1106 29.69V30.23C45.1106 32.08 43.6106 33.57 41.7706 33.57Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7705 33.57L13.5505 49.22C13.3005 50.43 12.1305 51.2 10.9205 50.96C9.7105 50.71 8.9405 49.54 9.1805 48.33L12.1305 33.88",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2305 33.57L38.4505 49.22C38.7005 50.43 39.8705 51.2 41.0805 50.96C42.2905 50.71 43.0605 49.54 42.8205 48.33L39.8705 33.88",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6516 40.46C36.6516 40.46 33.1116 37.63 26.0016 37.63C18.8916 37.63 15.3516 40.46 15.3516 40.46",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureFixtures);
export default __webpack_public_path__ + "static/media/FurnitureFixtures.32712c935c1ae66832607c89177183fc.svg";
export { ForwardRef as ReactComponent };